import { SupplierCreationForm } from 'components/Pages/Suppliers';
import { Scaffold } from 'layouts';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const SupplierCreationPage: React.FC = () => {
  const navigate = useNavigate();

  const onCreate = useCallback((): void => {
    navigate('/configuracoes/fornecedores');
  }, [navigate]);

  return (
    <Scaffold>
      <SupplierCreationForm onCreate={onCreate} />
    </Scaffold>
  );
};
